<template>
  <div id="app">
    <router-view></router-view>

    <p id="userID" style="visibility: hidden; position: fixed"></p>
    <p id="sessionID" style="visibility: hidden; position: fixed"></p>

    <div id="appVersion">
      <!-- v0.0.1 (DISCORD OAUTH) -->
    </div>

    <div ref="chatView" v-if="isChatVisible" class="resolved-chat">
      <div v-if="!isSession" class="resolved-chat-default">
        <div class="resolved-chat-header">
          <h1>Have a question? Let’s chat!</h1>
          <p>
            Hi 👋! Please fill out the form below to get connected with our
            customer support.
          </p>
        </div>
        <div class="resolved-chat-form">
          <InputWidget
            @changed="handleNameChange"
            class="chat-input"
            placeholder="Name"
            :isPassword="false"
          ></InputWidget>
          <InputWidget
            @changed="handleEmailChange"
            class="chat-input"
            placeholder="Email Address"
            :isPassword="false"
          ></InputWidget>
          <InputWidget
            @changed="handleReasonChange"
            class="chat-input"
            placeholder="Reason"
            :isPassword="false"
          ></InputWidget>
          <div @click="handleCreateChannel" class="chat-init-btn">
            Let's Start
          </div>
        </div>
      </div>
      <div v-else class="resolved-chat-session">
        <div class="resolved-chat-tag">
          Resolved Support
        </div>
        <div class="resolved-chat-agent-details">
          <img src="./assets/img/domlabs-square.svg" />
          <div>
            <h1>{{ staffName }}</h1>
            <p>Resolved Support Staff</p>
          </div>
        </div>
        <div class="resolved-chat-message-view" ref="messageView">
          <div v-for="(msg, i) in msgList" :key="i">
            <div
              class="first-user"
              v-if="msg.from['id'] == '739517132026675323'"
            >
              <h1>
                You -
                {{
                  new Date(msg.msg.timestamp).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                  })
                }}
              </h1>
              <p>{{ msg.msg.content }}</p>
            </div>
            <div class="second-user" v-else>
              <h1>
                {{ msg.from.username }} -
                {{
                  new Date(msg.msg.timestamp).toLocaleString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                    hour12: true,
                  })
                }}
              </h1>
              <p>{{ msg.msg.content }}</p>
              <!-- <div v-if="msg.msg.attachments.length != 0">
                <img :src="msg.msg.attachments[0].url" />
              </div>-->
            </div>
          </div>
        </div>

        <div class="resolved-chat-message-controls">
          <input v-model="msg" v-on:keyup.enter="sendMessage" />
          <div @click="sendMessage">
            <img src="./assets/img/send.svg" />
          </div>
        </div>
      </div>
    </div>
    <div class="resolved-chat-icon" @click="toggleChatView">
      <img v-if="!isChatVisible" src="./assets/img/message.svg" />
      <img v-else src="./assets/img/chatcross.svg" />
    </div>
  </div>
</template>
<!-- eslint-disable -->

<script>
import Axios from "axios";
import InputWidget from "./components/common/InputWidget.vue";
export default {
  components: {
    InputWidget,
  },
  name: "App",

  metaInfo: {
    title: "reSolved",
    meta: [
      {
        hid: "og:title",
        vmid: "og:title",
        name: "og:title",
        content: "The fastest and most advanced captcha solving service.",
      },

      {
        hid: "og:description",
        vmid: "og:description",
        name: "og:description",
        content:
          "Easily get hCaptcha and reCaptcha challenges solved using reSolved - the fastest and most advanced captcha solving service",
      },

      {
        hid: "og:image",
        vmid: "og:image",
        name: "og:image",
        content:
          "https://cdn.discordapp.com/attachments/732109131338612746/760613031699808326/resolved-logo.png",
      },

      {
        hid: "og:url",
        vmid: "og:url",
        name: "og:url",
        content: "https://www.resolved.gg/",
      },

      {
        hid: "twitter:title",
        vmid: "twitter:title",
        property: "twitter:title",
        content: "The fastest and most advanced captcha solving service.",
      },

      {
        hid: "twitter:description",
        vmid: "twitter:description",
        property: "twitter:description",
        content:
          "Easily get hCaptcha and reCaptcha challenges solved using reSolved - the fastest and most advanced captcha solving service",
      },

      {
        hid: "twitter:image",
        vmid: "twitter:image",
        property: "twitter:image",
        content:
          "https://cdn.discordapp.com/attachments/732109131338612746/760613031699808326/resolved-logo.png",
      },

      {
        hid: "twitter:card",
        vmid: "twitter:card",
        name: "twitter:card",
        content: "summary_large_image",
      },
    ],
  },
  data() {
    return {
      isChatVisible: false,
      isSession: false,
      msg: "",
      name: "",
      email: "",
      reason: "",
      msgList: [],
      staffName: "Waiting for staff...",
      userID: "",
      sessionID: "",
    };
  },
  mounted() {
    let that = this;
    if (localStorage.getItem("rchannel") && localStorage.getItem("rsecret")) {
      this.isChatVisible = true;
      this.isSession = true;
      this.$socket.emit("prev", {
        c_id: localStorage.getItem("rchannel"),
        secret: localStorage.getItem("rsecret"),
      });
    } else {
      this.isSession = false;
    }
    this.sockets.subscribe("channelCreate", (data) => {
      if (data.secret == localStorage.getItem("rsecret")) {
        localStorage.setItem("rchannel", data.channel);
        // localStorage.setItem("rsecret", data.secret);
        this.$socket.emit("joinChannel", {
          c_id: localStorage.getItem("rchannel"),
          secret: localStorage.getItem("rsecret"),
        });
        this.isSession = true;
      }
    });

    this.sockets.subscribe("prevMessages", (data) => {
      if (data.secret == localStorage.getItem("rsecret")) {
        this.msgList = data.msg;
        if (this.staffName === "Waiting for staff...") {
          this.msgList.forEach((v) => {
            if (v.from.id != "739517132026675323") {
              this.staffName = v.from.username;
              localStorage.setItem("staffName", v.from.username);
            }
          });
        }
        setTimeout(function() {
          that.$refs.messageView.scrollTop =
            that.$refs.messageView.scrollHeight;
        }, 50);
      }
    });
    this.sockets.subscribe("onMessage", (data) => {
      if (data.secret == localStorage.getItem("rsecret")) {
        if (this.staffName === "Waiting for staff...") {
          this.msgList.forEach((v) => {
            if (v.from.id != "739517132026675323") {
              this.staffName = v.from.username;
              localStorage.setItem("staffName", v.from.username);
            }
          });
        }
        this.msgList = data.msg;
        setTimeout(function() {
          that.$refs.messageView.scrollTop =
            that.$refs.messageView.scrollHeight;
        }, 50);
      }
    });
    this.sockets.subscribe("onClose", (v) => {
      if (v.secret == localStorage.getItem("rsecret")) {
        localStorage.removeItem("rchannel");
        localStorage.removeItem("rsecret");
        this.sockets.unsubscribe("onMessage");
        this.sockets.unsubscribe("onClose");
        this.sockets.unsubscribe("prevMessages");
        this.msgList = [];
        this.isSession = false;
        window.location.reload();
      }
    });
  },
  methods: {
    handleNameChange(v) {
      this.name = v;
    },
    handleEmailChange(v) {
      this.email = v;
    },
    handleReasonChange(v) {
      this.reason = v;
    },
    handleCreateChannel() {
      if (this.name == "" || this.email == "" || this.reason == "") {
        alert("All fields are mandatory");
        return;
      }
      var secret = new Date().valueOf();
      localStorage.setItem("rsecret", secret);
      this.$socket.emit("init", {
        name: this.name,
        email: this.email,
        type: this.reason,
        secret: new Date().valueOf(),
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async toggleChatView() {
      if (!this.isChatVisible) {
        this.isChatVisible = true;
        await this.sleep(100);
        this.$refs.chatView.classList.toggle("resolved-chat-expanded");
      } else {
        this.$refs.chatView.classList.toggle("resolved-chat-expanded");
        await this.sleep(100);
        this.isChatVisible = false;
      }
    },
    joinChannel() {
      this.$socket.emit("joinChannel", {
        c_id: localStorage.getItem("channel"),
        secret: localStorage.getItem("secret"),
      });
    },

    sendMessage() {
      const msg = this.msg;
      this.msg = "";
      if (localStorage.getItem("rchannel") && localStorage.getItem("rsecret")) {
        this.$socket.emit("message", {
          channel: localStorage.getItem("rchannel"),
          msg: msg,
          secret: localStorage.getItem("rsecret"),
          user: 0,
        });
      }
    },

    createChannel() {},
  },

  sockets: {
    onMessage: (v) => {},
    prevMessages: (v) => {},
    onClose: (v) => {},
    channelCreate: (v) => {},
  },
};
</script>

<style>
@import "./assets/styles/fonts.css";
#appVersion {
  position: fixed;
  color: #fefefe;
  left: 0;
  bottom: 0;
}
#app {
  color: white;
  font-family: "OpenSans";
  transition: 0.3s;
}
.resolved-chat {
  position: fixed;
  bottom: 100px;
  right: 20px;
  height: 439px;
  width: 294px;
  background-color: #0e0f11;
  border: 1px solid #222227;
  box-sizing: border-box;
  box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  transform: scale(1);
  transition: 0.3s;
  z-index: 1000;
}
.resolved-chat-expanded {
  transform: scale(1) !important;
}

.resolved-chat-header {
  width: 292px;
  margin-top: 1px;
  height: 140px;
  border-radius: 4px;
  background: #000000;
  padding-top: 23px;
}
.resolved-chat-header > h1 {
  font-size: 15px;
  line-height: 18px;
  color: #ffffff;
  box-sizing: border-box;
  margin: 0px 40px;
}
.resolved-chat-header > p {
  font-size: 14px;
  line-height: 23px;
  color: #ffffff;
  margin: 0px 40px;
  margin-top: 8px;
}
.resolved-chat-form {
  margin-top: 25px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.chat-input {
  margin: auto !important;
  max-width: 240px !important;
  width: 240px !important;
  margin-bottom: 12px !important;
}
.chat-init-btn {
  background-color: #eddb51 !important;
  border-radius: 10px;
  height: 45px !important;
  max-width: 270px;
  width: 270px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "OpenSans-SemiBold";
  font-size: 12px;
  color: #17181a !important;
  margin-top: 8px;
  cursor: pointer;
  transition: 0.3s;
  padding: 0px !important;
  margin: auto;
  box-shadow: 0px 2px 4px #000000;
}

.resolved-chat-tag {
  width: 292px;
  height: 40px;
  background: #000000;
  border-radius: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
}
.resolved-chat-agent-details {
  background: #161619;
  height: 49px;
  width: 292px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-left: 8px;
  box-shadow: 0px 2px 4px #000;
}
.resolved-chat-agent-details > div {
  padding-left: 8px;
}
.resolved-chat-agent-details > div > h1 {
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
}

.resolved-chat-agent-details > div > p {
  font-size: 10px;
  line-height: 9px;
  color: #9fa2ad;
  margin-top: 4px;
}
.resolved-chat-agent-details > img {
  border-radius: 50%;
  height: 32px;
  width: 32px;
  padding: 4px;
}
.resolved-chat-message-view {
  width: 292px;
  height: 285px;
  overflow-y: auto;
}
.resolved-chat-message-controls {
  width: 292px;
  height: 62px;
  background: #161619;
  border-radius: 0px 0px 4px 4px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resolved-chat-message-controls > input {
  width: 230px;
  border: 1px solid #222227;
  border-right: none;
  box-sizing: border-box;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  height: 31px;
  background: #0e0e10;
  outline: none;
  padding-left: 8px;
  color: #fff;
}
.resolved-chat-message-controls > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 29px;
  background: #000000;
  border: 1px solid #222227;
  cursor: pointer;
  border-radius: 0px 8px 8px 0px;
}
.resolved-chat-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #eddb51;
  border-radius: 50%;
  height: 64px;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 500;
  cursor: pointer;

}

.first-user {
  text-align: start;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 3px;
  padding-top: 4px;
  background-color: #161619;
  margin: 8px 5px 8px 100px;
  border-radius: 8px 0px 8px 8px;
  font-size: 12px;
  line-height: 18px;
}

.first-user > h1 {
  font-size: 8px;
  padding: 0px;
  margin: 0px !important;
  margin-top: 3px !important;
  color: #9fa2ad;
  font-weight: bold;
}

.first-user > p {
  word-break: break-word;
}

.second-user {
  background-color: #161619;
  margin: 8px 100px 8px 5px;
  text-align: start;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 3px;
  padding-top: 4px;
  border-radius: 4px;
  background-color: #161619;
  border-radius: 0px 8px 8px 8px;
  font-size: 12px;
  line-height: 18px;
}

.second-user > h1 {
  font-size: 8px;
  padding: 0px;
  margin: 0px !important;
  margin-top: 3px !important;
  color: #9fa2ad;
  font-weight: bold;
  /* font-family: "Roboto"; */
}

.second-user > p {
  word-break: break-word;
}
</style>
